export default __webpack_public_path__ + "48bb7009ab8b2d75d1e45705f276ccfc.svg";